document.addEventListener('DOMContentLoaded', () => {
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) filterToggle.addEventListener('click', () => filterPanel.classList.toggle('is-open'));
  const sort = document.querySelector('[data-sort-select]');
  if (sort) sort.addEventListener('change', () => sort.form.submit());

  const mainImage = document.querySelector('[data-product-main-image]');
  document.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    if (mainImage) mainImage.src = thumb.dataset.image;
    document.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }));
  const variant = document.querySelector('[data-variant-select]');
  if (variant) variant.addEventListener('change', () => {
    const option = variant.options[variant.selectedIndex];
    const price = document.querySelector('[data-product-price]');
    const sku = document.querySelector('[data-product-sku]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (sku) sku.textContent = option.dataset.sku || 'Disponible bajo pedido';
  });
});
